import { gql } from '@apollo/client';
import { mutate } from './Apollo';
import { getUrlHashParams } from '../../Helpers/getUrlHashParams';

const SEND_FORM_ERROR = gql`
  mutation SendFormError(
    $formId: String!
    $errorMessage: String!
    $componentId: String
    $iframeId: String
    $parentPage: String
    $userAgent: String!
  ) {
    sendFormError(
      formId: $formId
      errorMessage: $errorMessage
      componentId: $componentId
      iframeId: $iframeId
      parentPage: $parentPage
      userAgent: $userAgent
    ) {
      formErrorSent
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const sendFormErrorToGateway = ({ eventObject, errorObject }) => {
  if (
    ['production-na', 'production-eu', 'staging', 'development'].includes(
      process.env.NEXT_PUBLIC_ENV
    )
  ) {
    const parentPage = getUrlHashParams()?.parentPageUrl;
    mutate({
      mutation: SEND_FORM_ERROR,
      variables: {
        formId: String(eventObject.formId ?? ''),
        errorMessage: String(errorObject.message ?? ''),

        /**
         * If componentId, iFrameId or parentPage is not available, pass undefined
         */
        componentId:
          eventObject.componentId !== undefined
            ? String(eventObject.componentId)
            : undefined,

        iframeId:
          eventObject.iFrameId !== undefined
            ? String(eventObject.iFrameId)
            : undefined,

        parentPage: parentPage !== undefined ? String(parentPage) : undefined,
        userAgent: String(navigator?.userAgent ?? ''),
      },
    });
  }
};
